import React, { useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import Navbar from './components/layout/Navbar';
import BottomNav from './components/layout/BottomNav';
import Footer from './components/layout/Footer';
import Home from './pages/Home';
import News from './pages/News';
import Tools from './pages/Tools';
import Threads from './pages/Threads';
import AdminDashboard from './pages/admin/AdminDashboard';
import Login from './pages/admin/Login';
import { initKeepAlive } from './lib/pingService';
import { AuthProvider } from './context/AuthContext';
import { ThemeProvider } from './context/ThemeContext';
import ProtectedRoute from './components/auth/ProtectedRoute';

function App() {
  useEffect(() => {
    const cleanup = initKeepAlive();
    return cleanup;
  }, []);

  return (
    <AuthProvider>
      <ThemeProvider>
        <Router>
          <div className="flex flex-col min-h-screen bg-brand-bg transition-colors duration-200">
            <Navbar />
            {/* pb-24 accommodates the mobile bottom nav safely with its new taller height */}
            <main className="flex-grow pb-24 md:pb-0 w-full overflow-hidden">
              <Routes>
                <Route path="/" element={<Home />} />
                <Route path="/news" element={<News />} />
                <Route path="/tools" element={<Tools />} />
                <Route path="/threads" element={<Threads />} />
                <Route path="/admin/login" element={<Login />} />
                
                {/* Protected Admin Route */}
                <Route 
                  path="/admin" 
                  element={
                    <ProtectedRoute requiredRole="admin">
                      <AdminDashboard />
                    </ProtectedRoute>
                  } 
                />
                <Route path="*" element={<Navigate to="/" replace />} />
              </Routes>
            </main>
            <BottomNav />
            <Footer />
          </div>
        </Router>
      </ThemeProvider>
    </AuthProvider>
  );
}

export default App;